import { FETCH_DETAILS_REQUEST, FETCH_DETAILS_SUCCESS, FETCH_DETAILS_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const detailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DETAILS_REQUEST:
            return { ...state, loading: true };
        case FETCH_DETAILS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_DETAILS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default detailsReducer;
